import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const STORAGE_KEY = "sfReviewedListings";

const readStoredReviewedListings = (): Array<number> => {
	try {
		const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? "[]");
		if (!Array.isArray(parsed)) return [];
		return parsed.filter((x): x is number => typeof x === "number");
	} catch {
		return [];
	}
};

const persistReviewedListings = (listingIds: Array<number>) => {
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(listingIds));
	} catch {
		return;
	}
};

const initialState: { listingIds: Array<number> } = { listingIds: readStoredReviewedListings() };

export const reviewedListingsSlice = createSlice({
	name: "pricing.reviewedListings",
	initialState,
	reducers: {
		markListingsReviewed: (state, action: PayloadAction<Array<number>>) => {
			state.listingIds = Array.from(new Set([...state.listingIds, ...action.payload]));
			persistReviewedListings(state.listingIds);
		},
		unmarkListingsReviewed: (state, action: PayloadAction<Array<number>>) => {
			const toRemove = new Set(action.payload);
			state.listingIds = state.listingIds.filter((id) => !toRemove.has(id));
			persistReviewedListings(state.listingIds);
		},
	},
});
